import { RmaLgmCommodityNames } from '@harvestiq/constants';
import { range } from '@harvestiq/utils/range';

export const commodityTypeOptionsByCommodityName = {
  [RmaLgmCommodityNames.CATTLE]: {
    commodities: ['Calf Finishing', 'Yearling Finishing'],
    deductible: range(0, 150, 10),
    targetMarketLength: 10,
  },
  [RmaLgmCommodityNames.SWINE]: {
    commodities: ['Farrow to Finish', 'Finishing Operation', 'SEW Operation'],
    deductible: range(0, 20, 2),
    targetMarketLength: 5,
  },
};
